import * as React from 'react';

/**
 * Hook to automatically save and restore scroll position across page reloads.
 * Uses sessionStorage and a combination of ResizeObserver/Timeouts 
 * to handle React's asynchronous rendering cycle.
 */
export function useScrollRestoration() {
  React.useEffect(() => {
    if (typeof window === 'undefined') return;

    // We include hash for SPA routing so different pages have different scroll positions
    const STORAGE_KEY = `tefcms_scroll_pos_${window.location.pathname}${window.location.hash}`;

    // 1. Restore on Mount
    const savedPos = sessionStorage.getItem(STORAGE_KEY);
    if (savedPos !== null) {
      const targetY = parseInt(savedPos, 10);
      
      if (targetY > 0) {
        // Because data might load asynchronously and the DOM expands over time,
        // we use a combination of immediate and delayed attempts.
        
        let attempts = 0;
        const maxAttempts = 10;
        
        const attemptScroll = () => {
          if (document.body.scrollHeight >= targetY) {
            window.scrollTo({ top: targetY, behavior: 'auto' });
          } else {
            // Document hasn't expanded enough yet
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'auto' });
          }
          
          attempts++;
          if (attempts < maxAttempts) {
            setTimeout(attemptScroll, 100);
          }
        };

        // First attempt immediately after first paint
        setTimeout(attemptScroll, 50);
      }
    }

    // 2. Save on Unload / Scroll
    // Wir speichern beim beforeunload (besser für die Performance als bei *jedem* Scroll)
    const handleBeforeUnload = () => {
      sessionStorage.setItem(STORAGE_KEY, window.scrollY.toString());
    };

    // Für React SPAs speichern wir auch beim unmount
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      handleBeforeUnload(); // Speichere auch, wenn die Komponente normal unmounted
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
}
